export const VisitTypes = {
  medical: 'medical',
  medicalNow: 'medical_now',
  therapy: 'therapy',
  therapyNow: 'therapy_now',
  psychiatry: 'psychiatry',
  healthCoach: 'hc',
  needs: 'needs',
  successNow: 'success_coaching_now',
  success: 'success_coaching',
  crisis: 'crisis',
  // Utility service Types
  selfCare: 'self_care',
  community: 'community',
  successSelfCare: 'success_self_care',
} as const

export type VisitType = (typeof VisitTypes)[keyof typeof VisitTypes]

export const DiagnosisVisitTypes = {
  medical: 'medical',
  therapy: 'therapy',
  psychiatry: 'psychiatry',
} as const

export const PastVisitTypes = {
  medical: 'medical',
  therapy: 'therapy',
  therapyNow: 'therapy_now',
  psychiatry: 'psychiatry',
  healthCoach: 'hc',
  success: 'success_coaching',
  crisis: 'crisis',
} as const

export const isSuccessVisit = (visitType) => visitType === VisitTypes.success || visitType === VisitTypes.successNow

export const DisplayType = {
  [VisitTypes.medical]: 'Medical',
  [VisitTypes.medicalNow]: 'MedicalNow',
  [VisitTypes.therapy]: 'Therapy',
  [VisitTypes.therapyNow]: 'TalkNow',
  [VisitTypes.psychiatry]: 'Psychiatry',
  [VisitTypes.healthCoach]: 'Health Coaching',
  [VisitTypes.successNow]: 'Success Coaching',
  [VisitTypes.success]: 'Success Coaching',
  [VisitTypes.crisis]: 'CrisisNow',
  [VisitTypes.needs]: 'Basic Needs',
  // Utility service Types
  [VisitTypes.selfCare]: 'Self-Care',
  [VisitTypes.community]: 'Community',
  [VisitTypes.successSelfCare]: 'Success Self-Care',
}

export default VisitTypes
